import React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { ReconciliationTable } from "@/components/ReconciliationTable/ReconciliationTable";
import DateNavigationSection from "./DateNavigationSection";
import { FileText } from "lucide-react";

const DashboardTableSection = ({
  loading,
  dashboardData,
  cumulativeLoading,
  cumulativeFromDate,
  businessDay,
  highlightedRowId,
  viewTransaction,
  selectedBusinessDay,
  tempBusinessDay,
  setTempBusinessDay,
  setSelectedBusinessDay,
  setDebouncedBusinessDay,
  formatDate,
  getPreviousDay,
  getNextDay,
  navigateToDate,
}) => {
  if (loading) {
    return (
      <Card className="bg-gradient-card p-2 gap-0 shadow-modern border-modern-light animate-fade-in">
        <CardContent className="p-2 py-2">
          <div className="flex items-center justify-center p-4 space-y-4">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary-200 border-t-primary-600 mx-auto mb-2"></div>
              <p className="text-heading dark:text-white text-gray-900">{`Loading Dashboard`}</p>
              <p className="text-sm dark:text-white text-gray-600">
                {`Fetching reconciliation data...`}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="bg-gradient-card p-2 gap-0 shadow-modern border-modern-light animate-fade-in">
      <CardHeader className="pb-0">
        <div className="flex flex-col items-center space-y-0">
          {/* Enhanced Date Navigation */}
          <DateNavigationSection
            selectedBusinessDay={selectedBusinessDay}
            tempBusinessDay={tempBusinessDay}
            setTempBusinessDay={setTempBusinessDay}
            setSelectedBusinessDay={setSelectedBusinessDay}
            setDebouncedBusinessDay={setDebouncedBusinessDay}
            formatDate={formatDate}
            getPreviousDay={getPreviousDay}
            getNextDay={getNextDay}
            navigateToDate={navigateToDate}
          />
        </div>
      </CardHeader>
      <CardContent className="p-6 py-2">
        {dashboardData ? (
          <ReconciliationTable
            data={dashboardData.ChildNodes}
            calculatedCumilativeFromDate={
              dashboardData.calculatedCumilativeFromDate
            }
            filterState={{}}
            viewTransaction={viewTransaction}
            highlightedRowId={highlightedRowId}
            cumulativeLoading={cumulativeLoading}
            cumulativeFromDate={cumulativeFromDate}
            businessDay={businessDay}
          />
        ) : (
          <div className="flex items-center justify-center p-4 space-y-4">
            <div className="flex flex-col items-center justify-center gap-3">
              <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
                <FileText />
              </div>
              <div className="text-center">
                <p className="text-gray-600 font-medium">{`No records found`}</p>
                <p className="text-gray-500 text-xs mt-1">
                  {`Try adjusting your filters or date range`}
                </p>
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default DashboardTableSection;
